<template>
    <b-container>
       <h1>Edit Company Information</h1>
       <hr />
  <b-form @submit.prevent="updateCompany">
    
    <b-form-group
      id="company_name_group"
      label="Company Name"
      label-for="company_name"
      :class="{
        'text-danger': validation.hasError('company.name')
      }"
    >
      <b-form-input
        id="company_name"
        placeholder="Company Name"
        v-model="company.name"
      ></b-form-input>
      <div class="error-message">
        {{ validation.firstError('company.name') }}
      </div>
    </b-form-group>

    <!-- Address -->
    <b-form-group
      id="company_address_group"
      label="Address"
      label-for="company_address"
      :class="{
        'text-danger': validation.hasError('company.address')
      }"
    >
      <b-form-input
        id="company_address"
        placeholder="Address"
        v-model="company.address"
      ></b-form-input>
      <div class="error-message">
        {{ validation.firstError('company.address') }}
      </div>
    </b-form-group>

    <!-- Address 2 -->
    <b-form-group
      id="company_address2_group"
      label="Address 2"
      label-for="company_address2"
      :class="{
        'text-danger': validation.hasError('company.address2')
      }"
    >
      <b-form-input
        id="company_address2"
        placeholder="Address 2"
        v-model="company.address2"
      ></b-form-input>
      <div class="error-message">
        {{ validation.firstError('company.address2') }}
      </div>
    </b-form-group>

    <!-- City -->
    <b-form-group
      id="company_city_group"
      label="City"
      label-for="company_city"
      :class="{
        'text-danger': validation.hasError('company.city')
      }"
    >
      <b-form-input
        id="company_city"
        placeholder="City"
        v-model="company.city"
      ></b-form-input>
      <div class="error-message">
        {{ validation.firstError('company.city') }}
      </div>
    </b-form-group>

    <!-- State -->
    <b-form-group
      id="company_state_group"
      label="State"
      label-for="company_state"
      :class="{
        'text-danger': validation.hasError('company.state')
      }"
    >
      <b-form-input
        id="company_state"
        placeholder="State"
        v-model="company.state"
      ></b-form-input>
      <div class="error-message">
        {{ validation.firstError('company.state') }}
      </div>
    </b-form-group>

    <!-- Zipcode -->
    <b-form-group
      id="company_zipcode_group"
      label="Zipcode"
      label-for="company_zipcode"
      :class="{
        'text-danger': validation.hasError('company.zipcode')
      }"
    >
      <b-form-input
        id="company_zipcode"
        placeholder="Zipcode"
        v-model="company.zipcode"
      ></b-form-input>
      <div class="error-message">
        {{ validation.firstError('company.zipcode') }}
      </div>
    </b-form-group>

    <!-- Phone -->
    <b-form-group
      id="company_phone_group"
      label="Phone"
      label-for="company_phone"
      :class="{
        'text-danger': validation.hasError('company.phone')
      }"
    >
      <b-form-input
        id="company_phone"
        placeholder="Phone"
        v-model="company.phone"
      ></b-form-input>
      <div class="error-message"> {{ validation.firstError('company.phone') }}
      </div>
    </b-form-group>
 
      
      <!-- Email -->
      <b-form-group
        id="company_email_group"
        label="Email"
        label-for="company_email"
        :class="{
          'text-danger': validation.hasError('company.email')
        }"
      >
        <b-form-input
          id="company_email"
          placeholder="Email"
          v-model="company.email"
        ></b-form-input>
        <div class="error-message">
          {{ validation.firstError('company.email') }}
        </div>
      </b-form-group>
      
      <!-- Logo -->
      <b-form-group
        id="company_logo_group"
        label="Logo"
        label-for="company_logo"
        :class="{
          'text-danger': validation.hasError('company.logo')
        }"
      >
        <b-form-input
          id="company_logo"
          placeholder="Logo"
          v-model="company.logo"
        ></b-form-input>
        <div class="error-message">
          {{ validation.firstError('company.logo') }}
        </div>
      </b-form-group>
    

    <b-form-group id="company_theme_group" label="Theme" label-for="input-3">
        <b-form-select
          id="company_theme"
          v-model="company.theme"
          :options="themes"
        ></b-form-select>
      </b-form-group>

      <hr> <b-alert variant="danger" :show="validation.errors.length !== 0">There are validation errors</b-alert>
        <b-button variant="primary" v-if="validation.errors.length === 0" @click="updateCompany" class="float-right">Save
            Company</b-button>
  </b-form>
  </b-container>  
</template>

<script>
import CompanyDataService from "@/services/CompanyDataService";
import ReferenceDataService from "@/services/ReferenceDataService";
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
export default {
  data() {
    return {
      company: {},
      themes: []
    };
  },

  validators: {
  'company.name': function (value) {
    return Validator.value(value).required('The company name is required');
  },
  'company.address': function (value) {
    return Validator.value(value).required('The address is required');
  },
  'company.city': function (value) {
    return Validator.value(value).required('The city is required');
  },
  'company.state': function (value) {
    return Validator.value(value).required('The state is required');
  },
  'company.zipcode': function (value) {
    return Validator.value(value).required('The zipcode is required');
  },
  'company.phone': function (value) {
    return Validator.value(value).required('The phone number is required');
  },
  'company.email': function (value) {
    return Validator.value(value).required('The email is required').email('The email must be a valid email address');
  }
},
  async created() {

    this.themes = ReferenceDataService.theme_codes()

    CompanyDataService.getById(localStorage.getItem("company_id")).then((res) => {
      this.company = res.data;      
    });

  },
  methods: {
    handleError(err) {
      this.$emilt("error", err);
    },
    async updateCompany() {

      CompanyDataService.update(this.company.id, this.company).then(() => {
        this.successMessage = "Company updated successfully!";
        this.$emit("theme", this.company.theme);
        // vue router reload
        this.$router.go(this.$router.currentRoute);
      }).catch((err) => {
        console.error("An error occurred while updating the company:", err);
        this.errorMessage = "An error occurred while updating the company.";
      });
    },
  },
  watch: {
    company: function () {
      this.$validate()
    }
  }
};
</script>
